/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EvaluationState } from './EvaluationState';
import {
    instanceOfEvaluationState,
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';

/**
 * @type CreateEnumerationEvaluationOptionDtoEvaluationState
 * 
 * @export
 */
export type CreateEnumerationEvaluationOptionDtoEvaluationState = EvaluationState;


export function CreateEnumerationEvaluationOptionDtoEvaluationStateFromJSON(json: any): CreateEnumerationEvaluationOptionDtoEvaluationState {
    return CreateEnumerationEvaluationOptionDtoEvaluationStateFromJSONTyped(json, false);
}

export function CreateEnumerationEvaluationOptionDtoEvaluationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEnumerationEvaluationOptionDtoEvaluationState {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EvaluationStateFromJSONTyped(json, true) };
    return  EvaluationStateFromJSONTyped(json, true);
}

export function CreateEnumerationEvaluationOptionDtoEvaluationStateToJSON(value?: CreateEnumerationEvaluationOptionDtoEvaluationState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEvaluationState(value)) {
        return EvaluationStateToJSON(value as EvaluationState);
    }

    return {};
}

/**
 * Check if a given object implements the CreateEnumerationEvaluationOptionDtoEvaluationState interface.
 */
export function instanceOfCreateEnumerationEvaluationOptionDtoEvaluationState(value: any): value is CreateEnumerationEvaluationOptionDtoEvaluationState {
    if (instanceOfEvaluationState(value)) return true;
    return false;
}

